export const EQUIPMENT_TYPES = [
    "20 FR",
    "40 FR",
    "20 FT GP",
    "40 FT GP",
    "40 FT HQ",
    "20 FT OT",
    "40 FT OT"
]